module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4603-d2751dbb8e7b39058afdecaacdb250df.jpg";